/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Gettingstarted_Title1Inputs */

const he_help_gettingstarted_title1 = /** @type {(inputs: Help_Gettingstarted_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תחילת העבודה`)
};

const en_help_gettingstarted_title1 = /** @type {(inputs: Help_Gettingstarted_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getting Started`)
};

/**
* | output |
* | --- |
* | "Getting Started" |
*
* @param {Help_Gettingstarted_Title1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const help_gettingstarted_title1 = /** @type {((inputs?: Help_Gettingstarted_Title1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Gettingstarted_Title1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_help_gettingstarted_title1(inputs)
	return en_help_gettingstarted_title1(inputs)
});
export { help_gettingstarted_title1 as "help_gettingStarted_title" }